import React, { useEffect, useState, useCallback } from 'react';
import cx from 'classnames';

import Touchable from 'plaid-threads/Touchable';
import { InlineLink } from 'plaid-threads/InlineLink';
import { Callout } from 'plaid-threads/Callout';
import { Button } from 'plaid-threads/Button';

import { ItemType, InstitutionType, AccountsType } from './types';
import { AccountCard } from '.';
import { useUsers } from '../services';
import { getInstitutionById } from '../services/api';

interface Props {
  item: ItemType;
  username: string;
}

const ItemCard: React.FC<Props> = (props: Props) => {
  const [accounts, setAccounts] = useState<AccountsType>([]);
  const [institution, setInstitution] = useState<InstitutionType>({
    logo: '',
    name: '',
  });
  const [showAccounts, setShowAccounts] = useState(false);

  const { users, deleteItem } = useUsers();

  const plaid_institution_id = props.item.plaid_institution_id;
  const id = props.item.id;

  const getInst = useCallback(async inst_id => {
    const data = await getInstitutionById(inst_id);

    const inst: InstitutionType = {
      logo: data.data.institution.logo,
      name: data.data.institution.name,
    };

    setInstitution(inst);
  }, []);

  useEffect(() => {
    const allAccounts = users[props.username].accounts;
    const itemAccounts: AccountsType = (allAccounts as {
      [key: string]: any;
    })[id];
    setAccounts(itemAccounts || []);
    getInst(plaid_institution_id);
  }, [getInst, plaid_institution_id, id, props.username, users]);

  return (
    <div className="box">
      <div className={cx('card', 'item-card', showAccounts && 'expanded')}>
        <Touchable
          className="item-card__clickable"
          onClick={() => setShowAccounts(current => !current)}
        >
          {institution != null && (
            <div className="item-card__column-1">
              <img
                className="item-card__img"
                src={`data:image/jpeg;base64,${institution.logo}`}
                alt={institution && institution.name}
              />
              <p>{institution && institution.name}</p>
            </div>
          )}
        </Touchable>
        <Button
          secondary
          centered
          inline
          small
          className="remove__btn"
          onClick={() => deleteItem(id, props.username)}
        >
          Remove
        </Button>
      </div>
      {showAccounts && accounts.length > 0 && (
        <div>
          {accounts.map((account, index) => (
            <div key={index}>
              <AccountCard
                transactions={users[props.username].transactions}
                account={account}
                username={props.username}
              />
            </div>
          ))}
        </div>
      )}
      {showAccounts && accounts.length === 0 && (
        <Callout>
          No transactions or accounts have been retrieved for this item. See the{' '}
          <InlineLink href="https://github.com/plaid/pattern/blob/master/docs/troubleshooting.md">
            {' '}
            troubleshooting guide{' '}
          </InlineLink>{' '}
          to learn about receiving transactions webhooks with this sample app.
        </Callout>
      )}
    </div>
  );
};

ItemCard.displayName = 'ItemCard';

export default ItemCard;
